import { ICommonOrder, ICommonRemoveItemFromCartRequest } from '@cuspar/ywt.ch.model';
import { create } from 'zustand';
import { orderAPI } from './api/order';

type orderStore = {
  order?: ICommonOrder;
  orders: ICommonOrder[];
  getOrderById: (orderId: string, checkAvailability?: boolean) => Promise<void>;
  deleteOrderById: (orderId: string) => Promise<void>;
  removeItemFromOrder: (orderId: string, item: ICommonRemoveItemFromCartRequest) => Promise<void>;
  getMyOrders: (page?: number, size?: number) => Promise<void>;
  finalizeOrder: (orderId: string, paymentMethodId?: string | null) => Promise<boolean>;
  applyCoupon: (orderId: string, coupon: string) => Promise<boolean>;
  removeCoupon: (orderId: string) => Promise<boolean>;
  createRenewalOrder: (domains: string[]) => Promise<ICommonOrder | undefined>;
  createRestoreOrder: (domain: string) => Promise<ICommonOrder | undefined>;
  consolidateRenewalOrders: () => Promise<ICommonOrder | undefined>;
};

export const useOrderStore = create<orderStore>((set, _get) => ({
  order: undefined,
  orders: [],
  getOrderById: async (orderId: string, checkAvailability = false) => {
    const response = await orderAPI.getOrderById(orderId, checkAvailability);
    if (response.success) set({ order: response.data });
  },
  getMyOrders: async (page = 1, size = 10) => {
    const response = await orderAPI.getMyOrders(page, size);
    if (response.success) set({ orders: response.data });
  },
  removeItemFromOrder: async (orderId: string, item: ICommonRemoveItemFromCartRequest) => {
    const response = await orderAPI.removeItemFromOrder(orderId, item);
    if (response.success) set({ order: response.data });
  },
  deleteOrderById: async (orderId: string) => {
    await orderAPI.deleteOrderById(orderId);
    if (_get().order?.id === orderId) set({ order: undefined });
    set({ orders: _get().orders.filter((o) => o.id !== orderId) });
  },
  applyCoupon: async (orderId: string, coupon: string) => {
    const response = await orderAPI.applyCoupon(orderId, coupon);
    if (response.success) set({ order: response.data });
    return response.success;
  },
  removeCoupon: async (orderId: string) => {
    const response = await orderAPI.removeCoupon(orderId);
    if (response.success) set({ order: response.data });
    return response.success;
  },
  createRenewalOrder: async (domains: string[]) => {
    const response = await orderAPI.createRenewalOrder(domains);
    if (response.success) {
      set({ order: response.data });
      return response.data;
    }
  },
  createRestoreOrder: async (domain: string) => {
    const response = await orderAPI.createRestoreOrder(domain);
    if (response.success) {
      set({ order: response.data });
      return response.data;
    }
  },
  consolidateRenewalOrders: async () => {
    const response = await orderAPI.consolidateRenewalOrders();
    if (response.success) {
      set({ order: response.data });
      return response.data;
    }
  },
  finalizeOrder: async (orderId: string, paymentMethodId?: string | null) => {
    const response = await orderAPI.finalizeOrder(orderId, paymentMethodId);
    if (response.success) set({ order: response.data });
    return response.success;
  },
}));
